import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router';

import { ORGANIZATION_DASHBOARD_PATH } from '../../constants';
import { addNotification, defaultDismiss } from '../../helpers/notification';
import { clearOrganizationMessages, userLicenseSuccessStrip } from '../../redux/actions';
import LoaderWidget from '../../components/Loader';

const StripOrganizationPaymentSuccessFeedbackInternalPage = (props) => {
  useEffect(() => {
    const params = new URLSearchParams(props.location.search || '');
    const sessionId = params.get('session_id');
    props.userLicenseSuccessStrip(sessionId);
  }, [props.location.search]);

  useEffect(() => {
    if (!!props.actionSuccessMessage) {
      addNotification({
        title: 'License purchase successfully completed',
        message: props.actionSuccessMessage,
        type: 'success',
        dismiss: { ...defaultDismiss, duration: 5000 },
      });
      props.history.replace(ORGANIZATION_DASHBOARD_PATH);
    }
  }, [props.actionSuccessMessage]);

  useEffect(() => {
    if (!!props.actionFailureMessage) {
      addNotification({
        title: 'Failed to request license purchase',
        message: props.actionFailureMessage,
        type: 'danger',
        dismiss: { ...defaultDismiss, duration: 5000 },
      });
      props.history.replace(ORGANIZATION_DASHBOARD_PATH);
    }
  }, [props.actionFailureMessage]);

  return <LoaderWidget />;
};

const mapStateToProps = (state) => {
  return {
    actionFailureMessage: state.Organization.licensesActionFailureMessage,
    actionSuccessMessage: state.Organization.licensesActionSuccessMessage,
  };
};

export const StripOrganizationPaymentSuccessFeedback = withRouter(
  connect(mapStateToProps, { clearOrganizationMessages, userLicenseSuccessStrip })(
    StripOrganizationPaymentSuccessFeedbackInternalPage
  )
);

export const StripOrganizationPaymentCancelFeedback = () => {
  useEffect(() => {
    addNotification({
      title: 'Failed to request license purchase',
      message: 'Payment flow has not been completed.',
      type: 'danger',
      dismiss: { ...defaultDismiss, duration: 5000 },
    });
  }, []);

  return <Redirect to={{ pathname: ORGANIZATION_DASHBOARD_PATH }} />;
};
